export var ServiceType;
(function (ServiceType) {
    ServiceType["SALE"] = "sale";
    ServiceType["SERVICE"] = "service";
})(ServiceType || (ServiceType = {}));
//# sourceMappingURL=ServiceType.js.map